import { memberScope } from '../lib/organization/memberScope';
import { useAuth } from './useAuth';
import { useOrganizationProfile } from './useOrganization';

/**
 * The scope of the signed-in member, for the menus (`src/config/navigationModules.ts`): the data
 * domains they are limited to, empty for no restriction. The same array while the record is the same.
 */
export function useMemberScope(): readonly string[] {
  const { user } = useAuth();
  return memberScope(useOrganizationProfile(), user?.id);
}
